/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespAppliedFilters_viewer$ref = any;
type SbSharedRefineMenuFilters_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenu_viewer$ref: FragmentReference;
export type SbRespRefineMenu_viewer = {|
  +isDeliveryOptionsDisabled: ?boolean,
  +isSbSharedRefineMenuDisplayPrefsSelectEnabled: ?boolean,
  +$fragmentRefs: SbRespAppliedFilters_viewer$ref & SbSharedRefineMenuFilters_viewer$ref,
  +$refType: SbRespRefineMenu_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isDeliveryOptionsDisabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NON_MVP_SEARCH_BROWSE",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '39f209dc12eb170b2cfa899dbe128ec4';
module.exports = node;
